import { ReactNode, useMemo, useState } from 'react';
import SiteLookupMapContext, { SelectedSite } from './SiteLookupMapContext';

type Props = {
  children: ReactNode;
};

const SiteLookupMapProvider = ({ children }: Props) => {
  const [isMapExtended, setIsMapExtended] = useState(true);
  const [selectedSite, setSelectedSite] = useState<SelectedSite | null>(null);
  const [hoveredSiteId, setHoveredSiteId] = useState<string | null>(null);

  const contextValue = useMemo(
    () => ({
      hoveredSiteId,
      isMapExtended,
      selectedSite,
      setHoveredSiteId,
      setIsMapExtended,
      setSelectedSite,
      toggleIsMapExtended: () => setIsMapExtended((old) => !old),
    }),
    [hoveredSiteId, isMapExtended, selectedSite],
  );

  return <SiteLookupMapContext.Provider value={contextValue}>{children}</SiteLookupMapContext.Provider>;
};

export default SiteLookupMapProvider;
